module.exports = __webpack_public_path__ + "img/video-22.ed0aa4e0.png";